var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.8,0C2.5,0,2.3,0.2,2.3,0.5v15c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-15C3.3,0.2,3.1,0,2.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,7.6l-2.4-2.4c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7L12,7.5H6.8v-7C6.8,0.2,6.6,0,6.3,0 S5.8,0.2,5.8,0.5v15C5.8,15.8,6,16,6.3,16s0.5-0.2,0.5-0.5v-7h5.1L10.4,10c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.2,0.4,0.2 c0.1,0,0.3-0.1,0.4-0.2l2.4-2.4C13.7,8.1,13.7,7.8,13.5,7.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNav);
export default __webpack_public_path__ + "static/media/Open-Nav.610da92d4d54dbb5d5b3a62c843b39ce.svg";
export { ForwardRef as ReactComponent };